import { render } from "./App.vue?vue&type=template&id=72cc961e"
const script = {}
script.render = render

export default script